import { Modal } from 'antd'

import { CameraCapture } from './camera-capture'
import styles from './camera-capture-modal.module.scss'

type Props = {
  open: boolean
  onCapture: (dataUrl: string) => void
  onClose: () => void
}

export const CameraCaptureModal = ({ open, onCapture, onClose }: Props) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={720}
      centered
      title='Take a photo'
      className={styles.modal}>
      <CameraCapture active={open} onCapture={onCapture} onCancel={onClose} />
    </Modal>
  )
}
